import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter, Route, Switch, browserHistory} from 'react-router-dom';
import { rootReducer } from './reducers';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { logUser, logout } from './actions';
import { requireAuthentication } from './components/Authorization';
import { getSession } from './gateways/session'

// Styles
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss'
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss'
// Import Date picker styles
import 'react-datepicker/dist/react-datepicker.css';

// Containers
import Full from './containers/Full/'

// Views
import Login from './views/Pages/Login/'
import Logout from './views/Pages/Logout/'
import SignUp from './views/Pages/SignUp/'
import ResetPassword from './views/Pages/ResetPassword/'
import Register from './views/Pages/Register/'
import Page404 from './views/Pages/Page404/'
import Page500 from './views/Pages/Page500/'

const store = createStore(rootReducer);

ReactDOM.render((
  <Provider store={store}>
    <HashRouter>
      <Switch>
        <Route exact path="/reset/:token" name="Reset Password" component={ResetPassword}/>
        <Route exact path="/register" name="Sign up" component={SignUp}/>
        <Route exact path="/login" name="Login" component={Login}/>
        <Route exact path="/logout" name="Logout" component={Logout}/>
        <Route exact path="/404" name="Page 404" component={Page404}/>
        <Route exact path="/500" name="Page 500" component={Page500}/>
        <Route path="/" name="Home" component={requireAuthentication(Full)}/>
      </Switch>
    </HashRouter>
  </Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js